// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cardContainer_l1xAe {
  display: flex;
  gap: 50px;
  padding: 16px;
  overflow-x: auto; 
  overflow-y: hidden; 
  white-space: nowrap; 
  cursor: grab;
  -webkit-overflow-scrolling: touch; 
  width: 100%; 
  box-sizing: border-box; 
  margin-top: 100px;
}

.cardContainer_l1xAe:active {
  cursor: grabbing;
}

.cardContainer_l1xAe,
.card_x09RN {
  -webkit-user-select: none;
          user-select: none; 
}

.card_x09RN {
  display: inline-block; 
  cursor: pointer;
  gap: 5px;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  text-align: center;
}

.cardHeader_JlDgE {
  font-size: 18px;
  font-weight: bold;
  background-color: #d8d8d8;
  border-radius: 4px;
  padding: 0 10px;
}

.cardBody_g7wOu {
  margin-top: 8px;
  padding: 0 10px;
  display: flex;
  flex-direction: column;
  p {
    font-weight: bold;
  }
  p,
  span {
    color: #000000 !important;
    margin: 0;
  }
}

.cardHeader_JlDgE {
}

.price_RZ3BO {
  font-size: 34px;
  font-weight: bold;
}

.subText_vMdLu {
  font-size: 12px;
}

.button_W1rlF {
  margin-top: 16px;
  padding: 8px 16px;
  background-color: #233f39;
  color: var(--white-background);
  border: none;
  border-radius: 999px;
  font-weight: bold;
  cursor: pointer;
  font-size: 16px;
}

.cardContainer_l1xAe::-webkit-scrollbar {
  display: none; 
}

.cardContainer_l1xAe {
  scrollbar-width: none; 
}

.selectedCard_YzcV_ {
  .cardHeader_JlDgE {
    background-color: var(--_16c098-color);
    color: var(--white-color);
  }

  .cardBody_g7wOu {
    p {
      color: #16c098 !important;
    }
  }

  .button_W1rlF {
    background-color: var(--_16c098-color);
  }
}

.pricingPageCard_Rg27E {
  background-color: var(--_10a37f-background);
  padding: 10px;
  color: var(--white-background);
  .cardHeader_JlDgE {
    background-color: #ffffff3b;
  }
  .cardBody_g7wOu {
    p,
    span {
      color: #ffffff !important;
    }
  }
}

.pricingPageCard_Rg27E.selectedCard_YzcV_ {
  background-color: var(--white-color);
  .cardHeader_JlDgE {
    background-color: var(--_10a37f-background);
  }
  .cardBody_g7wOu {
    p,
    span {
      color: #10a37f !important;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/PricingCard/PricingCard.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,iCAAiC;EACjC,WAAW;EACX,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB;IACE,iBAAiB;EACnB;EACA;;IAEE,yBAAyB;IACzB,SAAS;EACX;AACF;;AAEA;AACA;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,8BAA8B;EAC9B,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,sCAAsC;IACtC,yBAAyB;EAC3B;;EAEA;IACE;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE,2CAA2C;EAC3C,aAAa;EACb,8BAA8B;EAC9B;IACE,2BAA2B;EAC7B;EACA;IACE;;MAEE,yBAAyB;IAC3B;EACF;AACF;;AAEA;EACE,oCAAoC;EACpC;IACE,2CAA2C;EAC7C;EACA;IACE;;MAEE,yBAAyB;IAC3B;EACF;AACF","sourcesContent":[".cardContainer {\n  display: flex;\n  gap: 50px;\n  padding: 16px;\n  overflow-x: auto; \n  overflow-y: hidden; \n  white-space: nowrap; \n  cursor: grab;\n  -webkit-overflow-scrolling: touch; \n  width: 100%; \n  box-sizing: border-box; \n  margin-top: 100px;\n}\n\n.cardContainer:active {\n  cursor: grabbing;\n}\n\n.cardContainer,\n.card {\n  user-select: none; \n}\n\n.card {\n  display: inline-block; \n  cursor: pointer;\n  gap: 5px;\n  display: flex;\n  flex-direction: column;\n  border-radius: 8px;\n  text-align: center;\n}\n\n.cardHeader {\n  font-size: 18px;\n  font-weight: bold;\n  background-color: #d8d8d8;\n  border-radius: 4px;\n  padding: 0 10px;\n}\n\n.cardBody {\n  margin-top: 8px;\n  padding: 0 10px;\n  display: flex;\n  flex-direction: column;\n  p {\n    font-weight: bold;\n  }\n  p,\n  span {\n    color: #000000 !important;\n    margin: 0;\n  }\n}\n\n.cardHeader {\n}\n\n.price {\n  font-size: 34px;\n  font-weight: bold;\n}\n\n.subText {\n  font-size: 12px;\n}\n\n.button {\n  margin-top: 16px;\n  padding: 8px 16px;\n  background-color: #233f39;\n  color: var(--white-background);\n  border: none;\n  border-radius: 999px;\n  font-weight: bold;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.cardContainer::-webkit-scrollbar {\n  display: none; \n}\n\n.cardContainer {\n  scrollbar-width: none; \n}\n\n.selectedCard {\n  .cardHeader {\n    background-color: var(--_16c098-color);\n    color: var(--white-color);\n  }\n\n  .cardBody {\n    p {\n      color: #16c098 !important;\n    }\n  }\n\n  .button {\n    background-color: var(--_16c098-color);\n  }\n}\n\n.pricingPageCard {\n  background-color: var(--_10a37f-background);\n  padding: 10px;\n  color: var(--white-background);\n  .cardHeader {\n    background-color: #ffffff3b;\n  }\n  .cardBody {\n    p,\n    span {\n      color: #ffffff !important;\n    }\n  }\n}\n\n.pricingPageCard.selectedCard {\n  background-color: var(--white-color);\n  .cardHeader {\n    background-color: var(--_10a37f-background);\n  }\n  .cardBody {\n    p,\n    span {\n      color: #10a37f !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardContainer": `cardContainer_l1xAe`,
	"card": `card_x09RN`,
	"cardHeader": `cardHeader_JlDgE`,
	"cardBody": `cardBody_g7wOu`,
	"price": `price_RZ3BO`,
	"subText": `subText_vMdLu`,
	"button": `button_W1rlF`,
	"selectedCard": `selectedCard_YzcV_`,
	"pricingPageCard": `pricingPageCard_Rg27E`
};
export default ___CSS_LOADER_EXPORT___;
